(function Module() {
	'use strict';

	var Chart = require('chart.js');

	mySynch.factory('F360ChartService', [
		function f360ChartService() {
			
			var renderLabelsForPieChart = function(){
				var self = this;
				var ctx = self.chart.ctx;
				var fontSize = 12;
				var fontStyle = 'normal';
				var fontFamily = '"Helvetica Neue", Helvetica, Arial, sans-serif';
				ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
				ctx.fillStyle = '#000000';
				ctx.textAlign = 'center';
				ctx.textBaseline = 'bottom';

				self.data.datasets.forEach(function (dataset, i) {
					var meta = self.getDatasetMeta(i);

					if (!meta.hidden) {
						meta.data.forEach(function renderLabelForBar(element, index) {
							if (dataset.data[index] <= 0) {
								// don't show
								return;
							}
							var model = dataset._meta[Object.keys(dataset._meta)[0]].data[index]._model,
							midRadius = model.innerRadius + (model.outerRadius - model.innerRadius)/2,
							startAngle = model.startAngle,
							endAngle = model.endAngle,
							midAngle = startAngle + (endAngle - startAngle)/2;
							var x = midRadius * Math.cos(midAngle);
							var y = midRadius * Math.sin(midAngle);

						
							var datasetValuesOfIndex = _.map(_.map(self.data.datasets,"data"), function(dataArray){ return _.sum(dataArray); });
							var total = _.sum(datasetValuesOfIndex);


							
							var percent = String(Math.round(dataset.data[index]/total*100)) + "%";
							ctx.fillText(dataset.data[index], model.x + x , model.y + y - 5);
							ctx.fillText(`(${percent})`, model.x + x, model.y + y + 10);
							
						});
					}
				
				});
			};

			var renderLabelsForBarChart = function(){
				var self = this;
				var ctx = self.chart.ctx;
				var fontSize = 12;
				var fontStyle = 'normal';
				var fontFamily = '"Helvetica Neue", Helvetica, Arial, sans-serif';
				ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
				ctx.fillStyle = '#000000';
				ctx.textAlign = 'center';
				ctx.textBaseline = 'bottom';

				self.data.datasets.forEach(function (dataset, i) {
					var meta = self.getDatasetMeta(i);

					if (!meta.hidden) {
						meta.data.forEach(function renderLabelForBar(element, index) {
							if (dataset.data[index] <= 0) {
								// don't show
								return;
							}
							var model = dataset._meta[Object.keys(dataset._meta)[0]].data[index]._model;
										

							var datasetValuesOfIndex = _.map(_.map(self.data.datasets,"data"), function(dataArray){ return dataArray[index]; });
							var total = _.sum(datasetValuesOfIndex);

							var dataValue = dataset.data[index];
							var percent = String(Math.round(dataValue/total*100)) + "%";
						

							//------- vertical chart labels above the bars 
							ctx.fillText(dataset.data[index], model.x , model.y - 12);
							ctx.fillText(`(${percent})`, model.x, model.y);

						     //------- horizontal cahrt labels to the right of the bars 
						//	ctx.fillText(dataset.data[index], model.x + 20, model.y);
						//	ctx.fillText(`(${percent})`, model.x + 20, model.y + 10);
					
							
						
						    //var position = element.tooltipPosition();
							//ctx.fillText(dataValue, position.x, position.y + (position.y/2) - 10);
							//ctx.fillText(`(${percent})`, position.x, position.y + (position.y/2));
					  

                            var dataSetIndex = _.indexOf(self.data.datasets,dataset);
						   
							// here we alternate the position of the value labels to the left(negative direction) or right(positive direction)
							// based on the even/odd index of the datasets
							var x = 0;
							if(dataSetIndex % 2 == 0 ){
							  x	= -((model.width / 2) + 20);
							}else{
								x	= (model.width / 2) + 20;
							}
							 
							var y = (element.height() / 2);

						
						
							 
						//------ stacked vertical bar alternating labels	
							//ctx.fillText(dataset.data[index], model.x + x , model.y + y + 5);
						//	ctx.fillText(`(${percent})`, model.x  + x , model.y + y + 15);
							
						});
					}
				
				});
			};

			return {
				getBarChart: function getBarChart(barChart,customOptions, chartData, textTitle, stepSize = 5) {
					
					var data = {
						labels: _.get(chartData,'categoryLabels',[]),
						datasets: []
					};
					_.forEach(_.get(chartData,'seriesData',[]),function(seriesDataItem){
					   
					    var dataSet = {
							label: _.get(seriesDataItem,'label',""),
							backgroundColor: _.get(seriesDataItem, "backgroundColor"),
							data: _.get(seriesDataItem,"data",[]),
							borderColor: _.get(seriesDataItem, "borderColor"),
							borderWidth: _.get(seriesDataItem, "borderWidth"),
							hoverBackgroundColor: _.get(seriesDataItem, "hoverBackgroundColor"),
							hoverBorderColor: _.get(seriesDataItem, "hoverBorderColor"),
							yAxisID: "y-axis"	
						};
						data.datasets.push(dataSet);
					});

					var defaultOptions = {
						title: {
							display: true,
							text: textTitle,
							fontSize: 18,
						},
						responsive: true,
						maintainAspectRatio: false,
						legend: {
							display: true
						},
						scales: {
							xAxes: [{
								stacked: false,
								categoryPercentage: 0.5,
								barPercentage: 0.75,
								ticks: {
									autoSkip: false,
									maxRotation:	90,
								},
								beforeSetDimensions: function(axes) {
	 
								  var viewportWidth =  $(window).width();
	 
								  if(viewportWidth > 995){
									  _.set(axes,'options.ticks.minRotation', 0);
								  }else{
									 _.set(axes,'options.ticks.minRotation', 90);
								  }
								   
								 }
							}],
							yAxes: [{
								id: "y-axis",
								stacked: false,
								ticks: {
									autoSkip: false,
									beginAtZero: true,
									stepSize: stepSize,
									
								}
							}]
						},
						animation: {
							onComplete: renderLabelsForBarChart,
							onProgress : renderLabelsForBarChart
						}
					};

					var options = _.merge(defaultOptions,customOptions);

				return	new Chart(barChart, {
						type: 'bar',
						data: data,
						options: options
					});
				},
                //TODO: make this function more generic so that it can be more modular ( for example having an N number of series). Currently this function is setup to handle just two series.
				getCircleChart: function getCircleChart(circleChart,customOptions, datas, textTitle) {
					var label = [];
					var datacircleChart = [];
					datas.forEach(item => {
						label.push(item.name);
						datacircleChart.push(item.data);
					});
					var data = {
						labels: label,
						datasets: [
							{
								fill: true,
								backgroundColor: ['#5C93B4','#EF8666','#ededed'],
								fontColor: ['#000000','#000000','#000000'],	
								data: datacircleChart,
								borderColor: ['#5C93B4', '#EF8666','#ededed'],
								borderWidth: [2,2],
								hoverBackgroundColor: ['#3478A2','#EB6841','#d9d9d9'],
					        	hoverBorderColor: ['#3478A2','#EB6841','#d9d9d9']
							}
						]
					};
		
					var defaultOptions = {
						title: {
							display: true,
							text: textTitle
						},
						responsive: true,
						maintainAspectRatio: false,
						legend: {
							display: true
						},
						animation: {
							onComplete: renderLabelsForPieChart,
							onProgress : renderLabelsForPieChart
						}
					};
					// we start with default options for a chart  above and add/overwrite options that are passed in
					var options = _.merge(defaultOptions,customOptions);
		
				return	new Chart(circleChart, {
						type: 'pie',
						data: data,
						options: options
					});
				}
			};	
		}
	]);
})();
